import { TABLE_COLUMN_WIDTH } from "components/ModelCompare/constants";

import type { Section } from "../types";
import { enterpriseCampus24PoE } from "./products/enterpriseCampus24PoE";
import { enterpriseCampus48PoE } from "./products/enterpriseCampus48PoE";
import { enterpriseCampusAggregation } from "./products/enterpriseCampusAggregation";
import {
  dimensions,
  downlinkSpeed,
  etherlighting,
  mounting,
  poeAvailability,
  poeOutput,
  portCount,
  proAvSupport,
  uplinkSpeed,
} from "./properties";
import { generalRedundancy } from "./properties/generalRedundancy";

export const SwitchingEnterprise: Section = {
  properties: [
    dimensions,
    portCount,
    downlinkSpeed,
    uplinkSpeed,
    poeOutput,
    poeAvailability,
    etherlighting,
    proAvSupport,
    mounting,
    generalRedundancy,
  ],
  products: [
    enterpriseCampusAggregation,
    enterpriseCampus48PoE,
    enterpriseCampus24PoE,
    /** Still waiting on data */
    // enterpriseCampus48SPoE,
    // enterpriseCampus24SPoE,
  ],
  columnWidth: TABLE_COLUMN_WIDTH,
};
